import React from "react";
import { useGeneralContext } from "../../General/Context";
import { ToDateTimeString as toDateAndTime } from "../../../common/helper";
import IconThreeDots from "../../../layout/others/three-dots.svg";
import { usePrecandidateContext } from "../../precandidate/context/Context";
import { PreCandidateService } from "../../../services/PreCandidate";
import { useTranslation } from "react-i18next";
import YellowCircle from "../../../layout/icons_status/icon_status_inactive.svg";
import GreenCircle from "../../../layout/icons_status/icon_status_active.svg";
import GrayCircle from "../../../layout/icons_status/icon_status_default.svg";
import BlueCircle from "../../../layout/icons_status/icon_status_ia.svg";
import moment from "moment";
import { showWarning } from "../../../services/ModalService";

const PreCandidateListItem = ({
  preCandidate,
  setIsNewApplication,
  setEditModalTitle
}) => {
  const {
    setPrecandidate,
    setModalEditShow,
    openContactModal,
    openDeletePreCandidateModal,
    openHistoryModal,
    LoadManagers,
    openModalCreateInterviewOrScreenCall,
    setShowSelectDNALanguage,
    setPreCandidateId
  } = usePrecandidateContext();
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();

  const onHandlerEdit = (event, _preCandidateId) => {
    event.stopPropagation();
    PreCandidateService.GetPrecandidateById(_preCandidateId).then((result) =>
      setPrecandidate(result)
    );
    LoadManagers();
    setModalEditShow(true);
  };

  function onHandleNewApllication(event, _preCandidateId) {
    event.stopPropagation();
    setEditModalTitle(t("Apply new application"));
    PreCandidateService.GetPrecandidateById(_preCandidateId).then((result) => {
      result.applicationDate = undefined;
      result.recommendedByName = undefined;
      result.recommendedByEmail = undefined;
      result.candidateSourceId = undefined;
      result.isCapturedByMe = undefined;
      result.comment = undefined;
      result.managerId = userInformation.id;
      result.isNewApplication = true;
      setIsNewApplication(true);
      setModalEditShow(true);

      setPrecandidate(result);
    });
    LoadManagers();
  }

  function openModalSendDNA(event, preCandidateId, hasPendingDocOnline) {
    event.stopPropagation();

    if (hasPendingDocOnline)
      showWarning(
        t(
          "There is a pending docOnline, do you wish to send another docOnline?"
        ),
        () => {
          setPreCandidateId(preCandidateId);
          setShowSelectDNALanguage(true);
        }
      );
    else {
      setPreCandidateId(preCandidateId);
      setShowSelectDNALanguage(true);
    }
  }

  function callCandidate(event) {
    event.stopPropagation();
  }

  return (
    <tr
      onClick={(event) => openDeletePreCandidateModal(event, preCandidate.id)}
    >
      <td className="name text-truncate" title={preCandidate.fullName}>
        {preCandidate.fullName}
      </td>
      <td className="email text-truncate" title={preCandidate.emailAddress}>
        {preCandidate.emailAddress}
      </td>
      <td className="phone text-truncate" title={preCandidate.phoneNumber}>
        <a href={`tel:${preCandidate.phoneNumber}`} onClick={callCandidate}>
          {preCandidate.phoneNumber}
        </a>
      </td>
      <td
        className="phone text-truncate"
        title={preCandidate.techAreaDescription}
      >
        {preCandidate.techAreaDescription}
      </td>
      <td
        className="phone text-truncate"
        style={{ paddingLeft: "10px" }}
        title={preCandidate.techRoleDescription}
      >
        {preCandidate.techRoleDescription}
      </td>
      <td
        className="status text-truncate"
        title={t(preCandidate.availabilityStatus)}
      >
        {t(preCandidate.availabilityStatus)}
      </td>
      <td
        className="contact text-truncate"
        title={
          preCandidate.nextContact !== null
            ? moment(preCandidate.nextContact).format("DD-MM-YYYY HH:mm")
            : ""
        }
      >
        {toDateAndTime(preCandidate.nextContact)}
      </td>
      <td className="manager text-truncate" title={preCandidate.managerName}>
        {preCandidate.managerName}
      </td>
      <td
        className="created text-truncate"
        title={moment(preCandidate.createdDate).format("DD-MM-YYYY")}
      >
        {moment(preCandidate.createdDate).format("DD-MM-YYYY")}
      </td>
      <td className="pc-actions" id="actions">
        <div className="dropdown">
          <button
            className="action-button"
            type="button"
            id="export"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img src={IconThreeDots} alt="threedots" title={t("Options")} />
          </button>
          <ul className="dropdown-menu adjust-dropdown" aria-labelledby="more">
            <li>
              <a
                href="#!"
                className="dropdown-item"
                onClick={(event) =>
                  openDeletePreCandidateModal(event, preCandidate.id)
                }
                title={t("Details")}
                data-bs-toggle="tooltip"
              >
                {t("Details")}
              </a>
            </li>
            {userInformation.permissions.Create_Edit_PreCand && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  onClick={(event) => onHandlerEdit(event, preCandidate.id)}
                  title={t("Edit")}
                  data-bs-toggle="tooltip"
                >
                  {t("Edit")}
                </a>
              </li>
            )}
            {userInformation.permissions.Create_Edit_PreCand && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  onClick={(event) =>
                    onHandleNewApllication(event, preCandidate.id)
                  }
                  title={t("New Application")}
                  data-bs-toggle="tooltip"
                >
                  {t("New Application")}
                </a>
              </li>
            )}
            {userInformation.permissions.Contact_PreCand && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  title={t("Contact")}
                  data-bs-toggle="tooltip"
                  onClick={(event) =>
                    openContactModal(
                      event,
                      preCandidate.id,
                      preCandidate.fullName
                    )
                  }
                >
                  {t("Contact")}
                </a>
              </li>
            )}
            <li>
              <a
                href="#!"
                className="dropdown-item"
                onClick={(event) => {
                  event.stopPropagation();
                  openModalCreateInterviewOrScreenCall(preCandidate.id, false);
                }}
                title={t("Screen Call")}
                data-bs-toggle="tooltip"
              >
                {t("Screen Call")}
              </a>
            </li>
            {userInformation.permissions.Create_Edit_Interview && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  onClick={(event) => {
                    event.stopPropagation();
                    openModalCreateInterviewOrScreenCall(preCandidate.id, true);
                  }}
                  title={t("Interview")}
                  data-bs-toggle="tooltip"
                >
                  {t("Interview")}
                </a>
              </li>
            )}
            {userInformation.permissions.Historic_PreCand && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  onClick={(event) =>
                    openHistoryModal(
                      event,
                      preCandidate.id,
                      preCandidate.fullName
                    )
                  }
                  title={t("History")}
                  data-bs-toggle="tooltip"
                >
                  {t("History")}
                </a>
              </li>
            )}
            {userInformation.permissions.DOCOnline_Interview && (
              <li>
                <a
                  href="#!"
                  className="dropdown-item"
                  onClick={(event) =>
                    openModalSendDNA(
                      event,
                      preCandidate.id,
                      preCandidate.hasPendingDocOnline
                    )
                  }
                  title={t("Send Doc Online")}
                  data-bs-toggle="tooltip"
                >
                  {t("Send Doc Online")}
                </a>
              </li>
            )}
          </ul>
        </div>
        <div>
          {preCandidate.docOnlineStatus !== null &&
            (preCandidate.docOnlineStatus === "New" ? (
              <img
                src={YellowCircle}
                alt="pending"
                title={t("DocOnline pending submission by the candidate.")}
                width="18px"
              />
            ) : preCandidate.docOnlineStatus === "Submitted" ? (
              <img
                src={GreenCircle}
                alt="submitted"
                title={t("DocOnline submitted by the candidate.")}
                width="18px"
              />
            ) : preCandidate.docOnlineStatus === "Expired" ? (
              <img
                src={GrayCircle}
                alt="expired"
                title={t("DocOnline expired.")}
                width="18px"
              />
            ) : preCandidate.docOnlineStatus === "IA" ? (
              <img
                src={BlueCircle}
                alt="ia"
                title={t("DocOnline generated by IA.")}
                width="18px"
              />
            ) : (
              <></>
            ))}
        </div>
      </td>
    </tr>
  );
};
export default PreCandidateListItem;
